import PropTypes from "prop-types";
import React from "react";

import { UrlProvider } from "../../../../../api/UrlProvider";
import withTranslations from "../../../../../hocs/withTranslations";
import ContentSection from "../../../common/ContentSection";
import SquaberLink from "../../../common/SquaberLink";
import LandingTypography from "../../../landingPage/pages/Homepage/components/LandingTypography";
import ArrowLeft from "../../../landingPage/pages/Homepage/assets/icons/arrow-left.svg";
import ChevronLeft from "../../../landingPage/pages/Homepage/assets/icons/chevron-left-1.svg";

function ContentWrapper({
  children,
  translate,
  locale,
  className,
  stock,
  isInsiderAnalysis
}) {
  const listUrl = UrlProvider.getLocalizedUrl(
    locale,
    isInsiderAnalysis ? "fe.insiderAnalysisList" : "fe.analysisList",
    { locale }
  );

  return (
    <LandingTypography>
      <div className={"flex items-center gap-3 flex-wrap mb-4 mt-4 md:mt-0 ml-1"}>
        <SquaberLink
          to={listUrl}
          className={"text-xs text-black-8 font-medium flex items-center gap-2"}
        >
          <img src={ArrowLeft} alt={""} width={16} height={16} />
          <span>{translate("Analysis list")}</span>
        </SquaberLink>
        {stock ? (
          <SquaberLink
            to={UrlProvider.getUrl("fe.stockPage", {
              locale,
              marketId: stock.market,
              stockId: stock.ticker
            })}
            className={
              "text-xs text-black-8 font-medium flex items-center gap-2"
            }
          >
            <img src={ChevronLeft} alt={""} width={16} height={16} />
            <span>{translate("Go to %{name}", { name: stock.ticker })}</span>
          </SquaberLink>
        ) : null}
      </div>
      <ContentSection className={className}>{children}</ContentSection>
    </LandingTypography>
  );
}

ContentWrapper.propTypes = {
  stock: PropTypes.shape({
    name: PropTypes.string,
    market: PropTypes.string,
    ticker: PropTypes.string
  }),
  className: PropTypes.string
};

export default withTranslations(ContentWrapper);
